import {useState} from "react";
import {SxProps, Theme} from "@mui/material";
import {Box, Colors} from "@bounce/shared/ui";

const NEUTRALIZE_LINKS_STYLE = `<style>
  a, a:link, a:visited, a:hover, a:active {
    cursor: default !important;
    pointer-events: none !important;
  }
</style>`;

type ContentSize = {w: number; h: number};

type HtmlFrameProps = {
  html: string;
  title: string;
  sx?: SxProps<Theme>;
  fitToWidth?: number;
};

const HtmlFrame = ({html, title, sx, fitToWidth}: HtmlFrameProps) => {
  const [size, setSize] = useState<ContentSize>();
  return (
    <Box
      component="iframe"
      title={title}
      srcDoc={NEUTRALIZE_LINKS_STYLE + html}
      sandbox="allow-same-origin"
      onLoad={(e) => {
        const el = e.currentTarget.contentDocument?.documentElement;
        if (fitToWidth && el) setSize({w: el.scrollWidth, h: el.scrollHeight});
      }}
      sx={{
        border: "none",
        display: "block",
        backgroundColor: Colors.bw.white,
        width: fitToWidth ? (size?.w ?? fitToWidth) : "100%",
        height: fitToWidth ? size?.h : undefined,
        zoom: fitToWidth && size ? fitToWidth / size.w : undefined,
        ...sx,
      }}
    />
  );
};

export default HtmlFrame;
